import * as React from 'react';
import { clsx } from 'clsx';
import { PriceDiff } from '../PriceDiff';
import { Summary } from '../Summary';
import { TPriceDiffTrend } from '../../../types/developerValuation/developerValuationPriceDynamics';

import * as styles from './styles.css';
import { UIHeading2, UIText1 } from '@cian/ui-kit';

interface IRealtyValuationSummariesProps {
  avgPrice: string;
  avgPriceSqm: string;
  priceDiff?: string | null;
  priceDiffPercent?: string | null;
  priceDiffTrend: TPriceDiffTrend;
  priceDiffTitle: string;
  action?: React.ReactElement<any>;
}

export function Summaries({
  avgPrice,
  avgPriceSqm,
  priceDiff,
  priceDiffPercent,
  priceDiffTrend,
  priceDiffTitle,
  action,
}: IRealtyValuationSummariesProps) {
  return (
    <div className={styles['container']}>
      <Summary label="Средняя цена за квартиру" testId="valuation_summary_avgPrice">
        <div className={styles['content']}>
          <UIHeading2>{avgPrice}</UIHeading2>
          <UIText1 whiteSpace="nowrap">{avgPriceSqm}</UIText1>
        </div>
      </Summary>
      <Summary label={priceDiffTitle} testId="valuation_summary_avgPriceSqm">
        <div className={styles['content']}>
          <UIHeading2>{priceDiff}</UIHeading2>
          {priceDiff && (
            <span className={clsx(styles['price-diff'])}>
              <PriceDiff diffTrend={priceDiffTrend} />
              <UIHeading2 color="current_color">{priceDiffPercent}</UIHeading2>
            </span>
          )}
        </div>
      </Summary>
      <div>{action}</div>
    </div>
  );
}
